<template>
  <!--  <page-header-wrapper>-->
  <div style="width: 100%;height:100vh;">
    <div style="margin-bottom: 20px">
      <a-button @click="getTimeSelect" style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 2%">
        日期选择
      </a-button>
      <!-- <a-date-picker v-if="this.timeflag" v-model="payTime"
                     style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%"
                     format="YYYY-MM-DD HH:mm:ss" allow-clear/> -->


      <a-date-picker v-if="timeflag" v-model="startTime"
        style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%" format="YYYY-MM-DD HH:mm:ss"
        allow-clear placeholder="开始时间" />

      <a-date-picker v-if="timeflag" v-model="endTime"
        style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%" format="YYYY-MM-DD HH:mm:ss"
        allow-clear placeholder="结束时间" />

      <a-button @click="selectTopData(1)"
        style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%">今日</a-button>
      <a-button @click="selectTopData(2)"
        style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%">昨天</a-button>
      <a-button @click="selectTopData(3)"
        style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%">近7天</a-button>
      <a-button @click="selectTopData(4)"
        style="background-color: rgb(234,233,232);border-radius: 10%;margin-left: 0.5%">近30天</a-button>
      <a-button @click="selectTopData(5)"
        style="background-color: rgba(105, 114, 238, 0.938);border-radius: 10%;margin-left: 0.5%">查询</a-button>

      <div style="background-color: rgb(240,242,245);padding-left: 1%;display: flex;width: 100%;margin-top: 0.5%">


        <a-card :bordered="false"
          style="background-color:white;width: 24%;height: 100%;border-radius: 5%;margin:0.5%;padding-top: 1%" hoverable @click="goToUser">
          <p>
            <font style="font-size: 20px;">用户总数</font>
          </p>
          <p>
            <font style="font-size: 20px;font-weight: bold;margin-top: 1%">{{ this.topData.totalUser }}</font>
          </p>
        </a-card>


        <!-- <a-card :bordered="false" style="background-color:white;width: 24%;border-radius: 5%;margin:0.5%;padding-top: 1%" hoverable @click="goToPayUser">
          <p>
            <font style="font-size: 20px">付费人数</font>
          </p>
          <p>
            <font style="font-size: 20px;font-weight: bold">{{ this.topData.totalPay }}</font>
          </p>
        </a-card> -->
        <!-- 
        <a-card :bordered="false"
                style="background-color:white;width: 24%;border-radius: 5%;margin:0.5%;padding-top: 1%">
          <p><font style="font-size: 20px">未消费人数</font></p>
          <p><font style="font-size: 20px;font-weight: bold">{{this.topData.noTotalPay}}</font></p>
        </a-card>

        <a-card :bordered="false"
                style="background-color:white;width: 24%;border-radius: 5%;margin:0.5%;padding-top: 1%">
          <p><font style="font-size: 20px">消耗品订阅总数（原始购买）</font></p>
          <p><font style="font-size: 20px;font-weight: bold">{{this.topData.vipTotal}}</font></p>
        </a-card> -->

        <!-- <a-card :bordered="false" style="background-color:white;width: 24%;border-radius: 5%;margin:0.5%;padding-top: 1%" hoverable @click="goToSubscribeUser">
          <p>
            <font style="font-size: 20px">连续订阅用户总数</font>
          </p>
          <p>
            <font style="font-size: 20px;font-weight: bold">{{ this.topData.subscribeTotal }}</font>
          </p>
        </a-card> -->

        <a-card :bordered="false" style="background-color:white;width: 24%;border-radius: 5%;margin:0.5%;padding-top: 1%"
          hoverable @click="goToRecharge">
          <p>累计充值金币收入</p>
          <p>
            <font style="font-size: 20px;font-weight: bold">{{ '$' }}{{ this.topData.buyMoney }}</font>
          </p>
        </a-card>


        <a-card :bordered="false" style="background-color:white;width: 24%;border-radius: 5%;margin:0.5%;padding-top: 1%"
          hoverable @click="goToVip">
          <p>累计购买会员收入</p>
          <p>
            <font style="font-size: 20px;font-weight: bold">{{ '$' }}{{ this.topData.vipMoney }}</font>
          </p>
        </a-card>
      </div>
    </div>

    <!-- 充值趋势 充值区域排行 -->
    <a-row :gutter="24">
      <div style="display:flex;justify-content: space-around">
        <div id="myChart" :style="{ width: '45%', height: '250%' }" style="background-color: white;border-radius: 5%">
        </div>
        <div id="myChart11" :style="{ width: '45%', height: '250%' }" style="background-color: white;border-radius: 5%">
        </div>
      </div>
    </a-row>

    <!-- 订阅趋势 充值方式累计金额 -->
    <a-row :gutter="24">
      <div style="display:flex;justify-content: space-around;">
        <div id="myChart1" style="width: 45%;margin-top: 1%;background-color: white;border-radius: 5%"
          :style="{ height: '400%' }"></div>
        <div id="myChart3" style="width: 45%;margin-top: 1%;background-color: white;border-radius: 5%"
          :style="{ height: '400%' }"></div>
      </div>
    </a-row>

    <!-- <div style="display:flex;height: 30%;width: 100%;margin-top: 2%">

      <a-row style="width: 32%;height: 100%;background-color: white;border-radius: 5%;margin-left: 1%;margin-left: 1%">
        <div style="display:flex;width: 100%;height: 100%">
          <div id="myChart" style="width: 100%;height: 100%"></div>
        </div>
      </a-row>

      <a-row style="width: 32%;height: 100%;background-color: white;border-radius: 5%;margin-left: 2%">
        <div style="display:flex;width: 100%;height: 100%">
          <div id="myChart1" style="width: 100%;height: 100%"></div>
        </div>
      </a-row>

      <a-row style="display:flex;width: 32%;height: 100%;background-color: white;border-radius: 5%;margin-left: 2%">
        <div style="display:flex;width: 10%;margin-left: 1%;margin-top: 10%;float:left" v-for="item in this.payTypeTotal">
          {{item.name}}:{{item.value}}
        </div>
        <div style="margin-left: 1%;margin-top: 8%;">
          <div v-for="item in this.payTypeTotal">
            {{item.name}}：{{item.value}}
          </div>
        </div>
        <div style="display:flex;width: 80%;height: 100%">
          <div id="myChart2" style="width: 100%;height: 100%">
          </div>
        </div>


      </a-row>
    </div> -->


    <div style="display:flex;height: 30%;width: 100%;margin-top: 2%">
      <!-- <a-row style="display:flex;width: 32%;height: 100%;background-color: white;border-radius: 5%;margin-left: 1%">
        <div style="margin-left: 1%;margin-top: 8%;">
          <div v-for="item in this.payTypeTotalMoney">
            {{item.name}}：{{item.value}}
          </div>
        </div>

        <div style="display:flex;width: 60%;height: 100%">
          <div id="myChart3" style="width: 100%;height: 100%"></div>
        </div>
      </a-row> -->

      <a-row style="display:flex;width: 32%;height: 100%;background-color: white;border-radius: 5%;margin-left: 2%">
        <div style="margin-left: 1%;margin-top: 8%; overflow-y: scroll;">
          <div v-for="item in this.rechargeAddress">
            {{ item.name }}：{{ item.value }}
          </div>
        </div>

        <div style="display:flex;width: 60%;height: 100%">
          <div id="myChart4" style="width: 100%;height: 100%"></div>
        </div>
      </a-row>

      <a-row style="display:flex;width: 32%;height: 100%;background-color: white;border-radius: 5%;margin-left: 2%">
        <div style="margin-left: 1%;margin-top: 8%;overflow-y: scroll;">
          <div v-for="item in this.vipAddress">
            {{ item.name }}：{{ item.value }}
          </div>
        </div>

        <div style="display:flex;width: 60%;height: 100%">
          <div id="myChart5" style="width: 100%;height: 100%"></div>
        </div>
      </a-row>

    </div>


  </div>
</template>

<script>

import {
  vipData,
  getTopData,
  gerVipAddressData,
  gerPayAddressData,
  gerPayMoneyData,
  payTypeData,

} from "@/api/system/data";
import {
  rechargeData,
  getRechargePal,
  getDiomnData,
  updateDisDiomn,
  updateOrderDiomn,
  updateRechargeDiomn,
  getVipData,
  getDisUserData,
  getRuioDataByDay,
  getInstutionByDay,
  getBuyVipData,
  getBuyData
} from '@/api/system/user';
import * as echarts from 'echarts';
import dayjs from 'dayjs';
import { getUserTotalData } from "@/api/biz/userForm";
// import {getRechargePal} from "@/api/system/user";

export default {
  name: 'Index',
  components: {},
  data() {
    return {
      timeflag: false,
      payTime: null,
      //ios充值趋势
      iosRecharge: [],
      //paypal充值趋势
      paypalRecharge: [],
      //充值趋势X轴
      xRecharge: [],

      topData: {}, //上方数据

      searchTime: null, //查询时间
      startTime: null,
      endTime: null,
      selectData: null, //日期选择 0-今日  1-昨天  2-近7天 3-近30天

      //ios充值会员趋势
      iosVipRecharge: [],
      //paypal充值会员趋势
      paypayRecharge: [],
      //shopify充值会员趋势
      shopifyRecharge: [],
      //充值会员趋势X轴
      vipXRecharge: [],


      //充值方式统计
      payTypeTotal: [],


      //充值方式累计金额统计
      payTypeTotalMoney: [],


      //充值地域排行
      rechargeAddress: [],

      //订阅地域排行
      vipAddress: [],
      totalNum: "0",
      disTotalNum: "0",
      orderNum: "0",
      rechargeNum: "0",
      userNum: "0",
      disUserNum: "0",
      noNum: "0",
      manNum: "0",
      womanNum: "0",
      dionNum: "0",
      userFlag: 'a',
      DisUserFlag: 'a',
      diominFlag: 'a',
      orderFlag: 'a',
      rechargeFlag: 'a',
      disDiominFlag: 'a',
      vipFlag: 'a',
      disVipFlag: 'a',
      buyFlag: 'a',
      DisbuyFlag: 'a',
      instutionList: [],
      storeList: []
    }
  },
  computed: {},
  created() {
    this.rechargeData()
    this.vipData()
    this.payTypeData()
    this.gerPayMoneyData()
    this.gerPayAddressData()
    this.gerVipAddressData()
    this.getTopData()
    this.drawLine1('a')
    this.updateUser('a')
    this.updateDiomn('a')
    this.updateDisDiomn('a')
    this.updateOrderDiomn('a')
    this.updateRechargeDiomn('a')
    this.updateVip('a')
    this.updateBuy('a')

  },
  mounted() {
    this.drawLine1();
    this.drawLine2();
    this.drawLine3();
    this.drawLine4();
    this.updateDiomn('a');
    this.updateVip('a');
    this.updateBuy('a')
    this.getTopData()
    this.gerPayAddressData()
    this.gerVipAddressData()
  },
  methods: {
    goToPayUser() {
      console.log('startTime:', this.startTime)
      console.log('endTime:', this.endTime)
      const query = {}
    
    // 转换 Moment 对象为字符串（兼容AntD的日期选择器）
    if (this.startTime && this.endTime) {
      query.startTime = this.startTime
      query.endTime = this.endTime
    } else {
      console.warn('未设置时间范围，将不带参数跳转')
    }
    query.isPay = 1
    // 调试：打印最终query
    console.log('跳转参数:', query)
      this.$router.push({
        path: '/app/user/biz',
        query: query
      })
    },
    goToSubscribeUser() {
      console.log('startTime:', this.startTime)
      console.log('endTime:', this.endTime)
      const query = {}
    
    // 转换 Moment 对象为字符串（兼容AntD的日期选择器）
    if (this.startTime && this.endTime) {
      query.startTime = this.startTime
      query.endTime = this.endTime
    } else {
      console.warn('未设置时间范围，将不带参数跳转')
    }
    query.subscribeStatus = '0,1,3,7,8,9,11,12,13'
    // 调试：打印最终query
    console.log('跳转参数:', query)
      this.$router.push({
        path: '/app/user/biz',
        query: query
      })
    },
    goToUser() {
      console.log('startTime:', this.startTime)
      console.log('endTime:', this.endTime)
      const query = {}
    
    // 转换 Moment 对象为字符串（兼容AntD的日期选择器）
    if (this.startTime && this.endTime) {
      query.startTime = this.startTime
      query.endTime = this.endTime
    } else {
      console.warn('未设置时间范围，将不带参数跳转')
    }
    // 调试：打印最终query
    console.log('跳转参数:', query)
      this.$router.push({
        path: '/app/user/biz',
        query: query
      })
    },
    goToVip() {
      console.log('startTime:', this.startTime)
      console.log('endTime:', this.endTime)
      const query = {}
    
    // 转换 Moment 对象为字符串（兼容AntD的日期选择器）
    if (this.startTime && this.endTime) {
      query.startTime = this.startTime
      query.endTime = this.endTime
    } else {
      console.warn('未设置时间范围，将不带参数跳转')
    }
    query.status = 1
    // 调试：打印最终query
    console.log('跳转参数:', query)
      this.$router.push({
        path: '/equity/vip',
        query: query
      })
    },
    goToRecharge() {
      console.log('startTime:', this.startTime)
      console.log('endTime:', this.endTime)
      const query = {}
    
    // 转换 Moment 对象为字符串（兼容AntD的日期选择器）
    if (this.startTime && this.endTime) {
      query.startTime = this.startTime
      query.endTime = this.endTime
    } else {
      console.warn('未设置时间范围，将不带参数跳转')
    }
    query.status = 1
    // 调试：打印最终query
    console.log('跳转参数:', query)
      this.$router.push({
        path: '/caiwu/recharge',
        query: query
      })
    },
    selectTopData(value) {
      let datas = {
        selectData: value,
        searchTime: null,
        searchTime1: null
      }
      if (value === 5) { // 5 代表自定义时间
        console.log("========="+value)
        if (this.startTime != null && this.endTime != null) {
          // if (this.endTime.isBefore(this.startTime)) {
          //   this.$message.error("结束时间不能小于开始时间，请重新选择时间范围！");
          //   return; // 不再请求后端
          // }
          datas.searchTime = this.startTime.format("YYYY-MM-DD HH:mm:ss");
          datas.searchTime1 = this.endTime.format("YYYY-MM-DD HH:mm:ss");
        } else {

          value = 1;
        }

      }

      // 新增：跳转时的时间参数处理（不影响原有功能）
      console.log("========="+value)
      this.prepareRouteParams(value, datas);

      getTopData(datas).then(response => {
        this.topData = response.data
      })
      
      this.loadAllData(datas);
    },
    prepareRouteParams(value, datas) {
      console.log("value========"+value)
      const query = {};
      // 只有特定情况才传递时间参数
      if (value === 5 && datas.searchTime && datas.searchTime1) {
        this.startTime = this.startTime.format("YYYY-MM-DD");
        this.endTime = this.endTime.format("YYYY-MM-DD");
      } else if ([1, 2, 3, 4].includes(value)) {
        // 为预定义范围添加时间参数
        const now = dayjs();
        let start, end;

        switch (value) {
          case 1: // 今日
            start = now.startOf('day');
            end = now.endOf('day');
            console.log(11111111111111111111)
            break;
          case 2: // 昨天
            start = now.subtract(1, 'day').startOf('day');
            end = now.subtract(1, 'day').endOf('day');
            break;
          case 3: // 近7天
            start = now.subtract(6, 'day').startOf('day');
            end = now.endOf('day');
            break;
          case 4: // 近30天
            start = now.subtract(29, 'day').startOf('day');
            end = now.endOf('day');
            break;
        }

        this.startTime = start.format("YYYY-MM-DD");
        this.endTime = end.format("YYYY-MM-DD");
        console.log("value========"+ this.startTime)
        console.log("value========"+ this.endTime)
      } else {
        this.startTime = null;
        this.endTime = null;
      }
    },

    loadAllData(datas) {
      // 所有接口都接收 startTime 和 endTime 参数
      this.drawLine1(datas);
      this.drawLine2(datas)
      this.drawLine4(datas);
      this.drawLine3(datas);
      this.gerVipAddressData(datas);
      this.gerPayAddressData(datas);
    },
    getTimeSelect() {
      if (this.timeflag) {
        this.getTopData()
        this.timeflag = false
      } else {
        this.timeflag = true
      }
    },


    getTopData() {
      getTopData({ selectData: null, searchTime: this.searchTime }).then(response => {
        this.topData = response.data
      })
    },
    updateUser(value) {
      console.log(value)
      this.userFlag = value
      getUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.userNum = data + "";
      });
    },
    updateDisUser(value) {
      console.log(value)
      this.DisUserFlag = value
      getDisUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.disUserNum = data + "";
      });
    },
    updateDiomn(value) {
      this.diominFlag = value
      getDiomnData({
        type: value
      }).then(res => {
        const data = res.data;
        this.totalNum = data + "";
      });
    },


    updateDisDiomn(value) {
      this.disDiominFlag = value
      updateDisDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.disTotalNum = data + "";
      });
    },


    updateOrderDiomn(value) {
      this.orderFlag = value
      updateOrderDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.orderNum = data + "";
      });
    },

    updateRechargeDiomn(value) {
      this.rechargeFlag = value
      updateRechargeDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.rechargeNum = data + "";
      });
    },

    updateVip(value) {
      this.vipFlag = value
      getVipData({
        type: value
      }).then(res => {
        const data = res.data;
        this.manNum = data + "";
      });
    },
    updateBuy(value) {
      this.buyFlag = value
      getBuyData({
        type: value
      }).then(res => {
        const data = res.data;

        data.forEach((el) => {
          if (el.type == '1') {
            this.womanNum = el.price + "";
          }
          if (el.type == '2') {
            this.dionNum = el.price + "";
          }
        });
      });
    },
    drawLine1(datas) {
      //获取机构概览
      // getInstutionByDay(datas).then(res => {
      //   this.xInstutiondata = [];
      //   this.yInstutiondata1 = [];
      //   this.xInstutiondata1s = [];
      //   this.yInstutiondata1s = [];
      //   if (res.data) {
      //     const data = res.data.orderNum;//  订单量
      //     data.forEach((el) => {
      //       this.xInstutiondata.push(el.times);
      //       this.yInstutiondata1.push(Number(el.nums));
      //     });
      //     res.data.orderMoney.forEach((el) => {
      //       // this.xInstutiondata1s.push(el.times);
      //       this.yInstutiondata1s.push(Number(el.moneys));
      //     });
      //     // debugger
      //     // console.log(this.xInstutiondata)
      //     // data1.forEach((el) => {
      //     //   this.yInstutiondata2.push(Number(el.num));
      //     // });

      //     // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例  myChart1
      //     let myChart = echarts.init(document.getElementById('myChart'));
      //     var option = {
      //       title: {
      //         text: '  用户充值概览'
      //       },
      //       tooltip: {
      //         trigger: 'item',
      //         triggerOn: "mousemove",
      //       },
      //       legend: {
      //         data: ['充值收入', '充值订单数']
      //       },


      //       grid: {
      //         left: '3%',
      //         right: '6%',
      //         bottom: '3%',
      //         containLabel: true
      //       },
      //       toolbox: {
      //         feature: {
      //           saveAsImage: {}
      //         }
      //       },
      //       xAxis: {
      //         type: 'category',
      //         boundaryGap: false,
      //         data: this.xInstutiondata
      //       },
      //       yAxis: {
      //         type: 'value'
      //       },
      //       series: [
      //         {
      //           name: '充值订单数',
      //           type: 'line',
      //           stack: 'Total',
      //           data: this.yInstutiondata1
      //         },
      //         {
      //           name: '充值收入',
      //           type: 'line',
      //           stack: 'Total',
      //           data: this.yInstutiondata1s
      //         }
      //       ]
      //     };
      //     // 绘制图表
      //     // myChart.setOption(option);
      //     option && myChart.setOption(option);
      //   }
      // });
      getInstutionByDay(datas).then(res => {
        this.xInstutiondata = [];
        this.yInstutiondata1s = [];
        if (res.data) {
          const data = res.data.orderMoney; // 只处理充值收入
          data.forEach((el) => {
            this.xInstutiondata.push(el.times); // x轴时间
            this.yInstutiondata1s.push(Number(el.moneys)); // y轴充值收入
          });

          // 初始化 ECharts
          let myChart = echarts.init(document.getElementById('myChart'));
          var option = {
            title: {
              text: '用户充值收入概览'
            },
            tooltip: {
              trigger: 'item',
              triggerOn: "mousemove",
            },
            legend: {
              data: ['充值收入']
            },
            grid: {
              left: '3%',
              right: '6%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '充值收入',
                type: 'line',
                data: this.yInstutiondata1s
              }
            ]
          };
          myChart.setOption(option);
        }
      });
    },
    drawLine2(datas) {
      getRuioDataByDay(datas).then(res => {
        this.dataList = [];
        if (res.data) {
          this.dataList = res.data;//  每日总量
          var chartDom = document.getElementById('myChart1');
          var myChart = echarts.init(chartDom);
          var option;

          option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: '数据值',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: true,
                  position: 'inner',
                  formatter: '{c}'


                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: true
                },
                data: this.dataList
              }
            ]
          };

          option && myChart.setOption(option);

          //1111
        }
      });
    },
    drawLine3(datas) {
      getRechargePal(datas).then(res => {
        this.rechargeData = [];
        if (res.data) {
          this.rechargeData = res.data;//  每日总量
          var chartDom = document.getElementById('myChart3');
          var myChart = echarts.init(chartDom);
          var option;
          option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: '充值数',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: true,
                  position: 'inner',
                  formatter: '{c}'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.rechargeData
              }
            ]
          };

          option && myChart.setOption(option);
        }
      });
    },
    drawLine4(datas) {
      //获取机构概览
      // getBuyVipData(datas).then(res => {
      //   this.xInstutiondata4 = [];
      //   this.yInstutiondata4 = [];
      //   this.yInstutiondata4s = [];
      //   if (res.data) {
      //     const data = res.data.orderNum;//  订单量
      //     data.forEach((el) => {
      //       this.xInstutiondata4.push(el.times);
      //       this.yInstutiondata4.push(Number(el.nums));
      //     });
      //     res.data.orderMoney.forEach((el) => {
      //       // this.xInstutiondata4.push(el.times);
      //       this.yInstutiondata4s.push(Number(el.moneys));
      //     });
      //     // debugger
      //     // console.log(this.xInstutiondata)
      //     // data1.forEach((el) => {
      //     //   this.yInstutiondata2.push(Number(el.num));
      //     // });

      //     // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例  myChart1
      //     let myChart11 = echarts.init(document.getElementById('myChart11'));
      //     var option = {
      //       title: {
      //         text: '  会员订阅概览'
      //       },
      //       tooltip: {
      //         trigger: 'item',
      //         triggerOn: "mousemove",
      //       },
      //       legend: {
      //         data: ['订阅收入', '订阅数']
      //       },


      //       grid: {
      //         left: '3%',
      //         right: '7%',
      //         bottom: '3%',
      //         containLabel: true
      //       },
      //       toolbox: {
      //         feature: {
      //           saveAsImage: {}
      //         }
      //       },
      //       xAxis: {
      //         type: 'category',
      //         boundaryGap: false,
      //         data: this.xInstutiondata4
      //       },
      //       yAxis: {
      //         type: 'value'
      //       },
      //       series: [
      //         {
      //           name: '订阅数',
      //           type: 'line',
      //           stack: 'Total',
      //           data: this.yInstutiondata4
      //         },
      //         {
      //           name: '订阅收入',
      //           type: 'line',
      //           stack: 'Total',
      //           data: this.yInstutiondata4s
      //         }
      //       ]
      //     };
      //     // 绘制图表
      //     // myChart.setOption(option);
      //     option && myChart11.setOption(option);
      //   }
      // });
      getBuyVipData(datas).then(res => {
        this.xInstutiondata4 = [];
        this.yInstutiondata4s = [];

        if (res.data) {
          const data = res.data.orderMoney; // 只处理订阅收入
          data.forEach((el) => {
            this.xInstutiondata4.push(el.times); // x轴时间
            this.yInstutiondata4s.push(Number(el.moneys)); // y轴订阅收入
          });

          // 初始化 ECharts
          let myChart11 = echarts.init(document.getElementById('myChart11'));
          var option = {
            title: {
              text: '会员订阅收入概览'
            },
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove'
            },
            legend: {
              data: ['订阅收入']
            },
            grid: {
              left: '3%',
              right: '7%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata4
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '订阅收入',
                type: 'line',
                data: this.yInstutiondata4s
              }
            ]
          };

          myChart11.setOption(option);
        }
      });

    },


    // gerVipAddressData() {
    //   gerVipAddressData().then(res => {
    //     this.vipAddress = [];
    //     if (res.data) {
    //       this.vipAddress = res.data;//  订单量
    //       // this.iosRecharge = data.iosRecharge;
    //       // this.paypalRecharge = data.paypalRecharge;
    //       // this.xRecharge = data.xRecharge;
    //
    //       let myChart = echarts.init(document.getElementById('myChart5'));
    //       var option = {
    //         title: {
    //           text: '订阅地域排行',
    //           top: 10,
    //           left: 20
    //         },
    //
    //         legend: {
    //           left: 'center',
    //           top: 'bottom',
    //           data: [
    //             'rose1',
    //             'rose2',
    //             'rose3',
    //             'rose4',
    //             'rose5',
    //             'rose6',
    //             'rose7',
    //             'rose8'
    //           ]
    //         },
    //         toolbox: {
    //           show: true,
    //           feature: {
    //             mark: {show: true},
    //             dataView: {show: true, readOnly: false},
    //             restore: {show: true},
    //             saveAsImage: {show: true}
    //           }
    //         },
    //
    //         series: [
    //           {
    //             name: 'Access From',
    //             type: 'pie',
    //             radius: ['40%', '70%'],
    //             avoidLabelOverlap: false,
    //
    //             // itemStyle: {
    //             //   normal: {
    //             //     label: {
    //             //       show: true,
    //             //       formatter: '{b} : {c}'
    //             //     }
    //             //   },
    //             //   labelLine: {show: false}
    //             // },
    //             label: {
    //               show: false,
    //               position: 'center'
    //             },
    //             itemStyle: {
    //               normal: {
    //                 label: {
    //                   show: true,
    //                   formatter: '{b} : {c}'
    //                 }
    //               },
    //               labelLine: {show: true}
    //             },
    //             emphasis: {
    //               label: {
    //                 show: true
    //               }
    //             },
    //             data: this.vipAddress
    //           }
    //         ]
    //       };
    //       // 绘制图表
    //       option && myChart.setOption(option);
    //     }
    //   });
    // },


    gerVipAddressData(datas) {
      gerVipAddressData(datas).then(res => {
        this.vipAddress = [];
        if (res.data) {
          this.vipAddress = res.data;//  每日总量
          var chartDom = document.getElementById('myChart5');
          var myChart = echarts.init(chartDom);
          var option;
          option = {
            title: {
              text: '订阅地域排行',
              top: 5,
              left: 20
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center',
              show: false
            },
            series: [
              {
                name: '数据值',
                type: 'pie',
                radius: ['40%', '70%'],
                center: ['50%', '60%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.vipAddress
              }
            ]
          };

          option && myChart.setOption(option);
        }
      });
    },


    // gerPayAddressData() {
    //   gerPayAddressData().then(res => {
    //     this.rechargeAddress = [];
    //     if (res.data) {
    //       this.rechargeAddress = res.data;//  订单量
    //       // this.iosRecharge = data.iosRecharge;
    //       // this.paypalRecharge = data.paypalRecharge;
    //       // this.xRecharge = data.xRecharge;
    //
    //       let myChart = echarts.init(document.getElementById('myChart4'));
    //       var option = {
    //         title: {
    //           text: '充值区域排行',
    //           top: 10,
    //           left: 20
    //         },
    //
    //         legend: {
    //           left: 'center',
    //           top: 'bottom',
    //           data: [
    //             'rose1',
    //             'rose2',
    //             'rose3',
    //             'rose4',
    //             'rose5',
    //             'rose6',
    //             'rose7',
    //             'rose8'
    //           ]
    //         },
    //         toolbox: {
    //           show: true,
    //           feature: {
    //             mark: {show: true},
    //             dataView: {show: true, readOnly: false},
    //             restore: {show: true},
    //             saveAsImage: {show: true}
    //           }
    //         },
    //         series: [
    //           {
    //             name: 'Access From',
    //             type: 'pie',
    //             radius: ['40%', '70%'],
    //             avoidLabelOverlap: false,
    //             // itemStyle: {
    //             //   normal: {
    //             //     label: {
    //             //       show: true,
    //             //       formatter: '{b} : {c}'
    //             //     }
    //             //   },
    //             //   labelLine: {show: true}
    //             // },
    //             itemStyle: {
    //               normal: {
    //                 label: {
    //                   show: true,
    //                   formatter: '{b} : {c}'
    //                 }
    //               },
    //               labelLine: {show: true}
    //             },
    //             emphasis: {
    //               label: {
    //                 show: true
    //               }
    //             },
    //             data: this.rechargeAddress
    //           }
    //         ]
    //       };
    //       // 绘制图表
    //       option && myChart.setOption(option);
    //     }
    //   });
    // },

    gerPayAddressData(datas) {
      gerPayAddressData(datas).then(res => {
        this.rechargeAddress = [];
        if (res.data) {
          this.rechargeAddress = res.data;//  每日总量
          var chartDom = document.getElementById('myChart4');
          var myChart = echarts.init(chartDom);
          var option;
          option = {
            title: {
              text: '充值区域排行',
              top: 5,
              left: 15
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center',
              show: false
            },
            series: [
              {
                name: '数据值',
                type: 'pie',
                radius: ['40%', '70%'],
                center: ['50%', '60%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.rechargeAddress
              }
            ]
          };

          option && myChart.setOption(option);
        }
      });
    },


    // gerPayMoneyData() {
    //   gerPayMoneyData().then(res => {
    //     this.payTypeTotalMoney = [];
    //     if (res.data) {
    //       this.payTypeTotalMoney = res.data;//  订单量
    //       // this.iosRecharge = data.iosRecharge;
    //       // this.paypalRecharge = data.paypalRecharge;
    //       // this.xRecharge = data.xRecharge;
    //
    //       let myChart = echarts.init(document.getElementById('myChart3'));
    //       var option = {
    //         title: {
    //           text: '充值方式累计金额统计',
    //           top: 10,
    //           left: 20
    //         },
    //
    //         legend: {
    //           left: 'center',
    //           top: 'bottom',
    //           data: [
    //             'rose1',
    //             'rose2',
    //             'rose3',
    //             'rose4',
    //             'rose5',
    //             'rose6',
    //             'rose7',
    //             'rose8'
    //           ]
    //         },
    //         toolbox: {
    //           show: true,
    //           feature: {
    //             mark: {show: true},
    //             dataView: {show: true, readOnly: false},
    //             restore: {show: true},
    //             saveAsImage: {show: true}
    //           }
    //         },
    //         series: [
    //           {
    //             name: '数据值',
    //             type: 'pie',
    //             // radius: [40, 400],
    //             center: ['50%', '50%'],
    //             avoidLabelOverlap: false,
    //             roseType: 'area',
    //             // itemStyle: {
    //             //   borderRadius: 5
    //             // },
    //             itemStyle: {
    //               normal: {
    //                 label: {
    //                   show: true,
    //                   formatter: '{b} : {c}'
    //                 }
    //               },
    //               labelLine: {show: true}
    //             },
    //             emphasis: {
    //               label: {
    //                 show: true
    //               }
    //             },
    //             data: this.payTypeTotalMoney
    //           }
    //         ]
    //       };
    //       // 绘制图表
    //       option && myChart.setOption(option);
    //     }
    //   });
    // },

    gerPayMoneyData() {
      gerPayMoneyData().then(res => {
        this.payTypeTotalMoney = [];
        if (res.data) {
          this.payTypeTotalMoney = res.data;//  订单量
          // this.iosRecharge = data.iosRecharge;
          // this.paypalRecharge = data.paypalRecharge;
          // this.xRecharge = data.xRecharge;

          let myChart = echarts.init(document.getElementById('myChart3'));
          var option = {
            title: {
              text: '充值方式累计金额',
              top: 0,
              left: 20
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '10%',
              left: 'center',
              show: false
            },
            toolbox: {
              show: true,
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                restore: { show: true },
                saveAsImage: { show: true }
              }
            },
            series: [
              {
                // name: '统计值值',
                type: 'pie',
                // radius: [40, 400],
                center: ['50%', '60%'],
                avoidLabelOverlap: false,
                roseType: 'area',
                // itemStyle: {
                //   borderRadius: 5
                // },
                itemStyle: {
                  normal: {
                    label: {
                      show: false,
                      position: 'outside',
                      formatter: '{b} : {c}'
                    }
                  },
                  labelLine: { show: true }
                },
                emphasis: {
                  label: {
                    show: false
                  }
                },
                data: this.payTypeTotalMoney
              }
            ]
          };
          // 绘制图表
          option && myChart.setOption(option);
        }
      });
    },


    payTypeData() {
      payTypeData().then(res => {
        this.payTypeTotal = [];
        if (res.data) {
          this.payTypeTotal = res.data;//  订单量
          // this.iosRecharge = data.iosRecharge;
          // this.paypalRecharge = data.paypalRecharge;
          // this.xRecharge = data.xRecharge;

          let myChart = echarts.init(document.getElementById('myChart2'));
          var option = {
            title: {
              text: '充值方式统计',
              top: 5,
              left: 10
            },
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '10%',
              left: 'center',
              show: false
            },
            toolbox: {
              show: true,
              feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                restore: { show: true },
                saveAsImage: { show: true }
              }
            },
            series: [
              {
                // name: '统计值值',
                type: 'pie',
                // radius: [40, 400],
                center: ['50%', '60%'],
                avoidLabelOverlap: false,
                roseType: 'area',
                // itemStyle: {
                //   borderRadius: 5
                // },
                itemStyle: {
                  normal: {
                    label: {
                      show: false,
                      position: 'outside',
                      formatter: '{b} : {c}'
                    }
                  },
                  labelLine: { show: true }
                },
                emphasis: {
                  label: {
                    show: false
                  }
                },
                data: this.payTypeTotal
              }
            ]
          };
          // 绘制图表
          option && myChart.setOption(option);
        }
      });
    },

    vipData() {
      vipData().then(res => {
        //ios充值会员趋势
        this.iosVipRecharge = [],
          //paypal充值会员趋势
          this.paypayRecharge = [],
          //shopify充值会员趋势
          this.shopifyRecharge = [],
          //充值会员趋势X轴
          this.vipXRecharge = []
        if (res.data) {

          //ios充值会员趋势
          this.iosVipRecharge = res.data.iosVipRecharge,
            //paypal充值会员趋势
            this.paypayRecharge = res.data.paypayRecharge,
            //shopify充值会员趋势
            this.shopifyRecharge = res.data.shopifyRecharge,
            //充值会员趋势X轴
            this.vipXRecharge = res.data.vipXRecharge

          let myChart = echarts.init(document.getElementById('myChart1'));
          var option = {
            title: {
              text: '订阅趋势',
              top: 10,
              left: 20
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['ios充值会员趋势', 'paypal充值会员趋势', 'shopify充值会员趋势']
            },


            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: this.vipXRecharge
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: this.iosVipRecharge,
                type: 'line',
                smooth: true
              },
              {
                data: this.iosVipRecharge,
                type: 'line',
                smooth: true
              },
              {
                data: this.shopifyRecharge,
                type: 'line',
                smooth: true
              }
            ]
          };
          // 绘制图表
          option && myChart.setOption(option);
        }
      });
    },

    rechargeData() {
      rechargeData().then(res => {
        //ios充值趋势
        this.iosRecharge = [],
          //paypal充值趋势
          this.paypalRecharge = [],
          //充值趋势X轴
          this.xRecharge = []
        if (res.data) {
          //ios充值趋势
          this.iosRecharge = res.data.iosRecharge,
            //paypal充值趋势
            this.paypalRecharge = res.data.paypalRecharge,
            //充值趋势X轴
            this.xRecharge = res.data.xRecharge

          let myChart = echarts.init(document.getElementById('myChart'));
          var option = {
            title: {
              text: '充值趋势',
              top: 10,
              left: 20
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['ios充值趋势', 'paypal充值趋势']
            },


            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: this.xRecharge
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: this.iosRecharge,
                type: 'line',
                smooth: true
              },
              {
                data: this.paypalRecharge,
                type: 'line',
                smooth: true
              }
            ]
          };
          // 绘制图表
          option && myChart.setOption(option);
        }
      });

    },


  },


}
</script>

<style lang="less" scoped>
@import "../../index.less";

blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}
</style>
